import script from "./Tabs.vue?vue&type=script&setup=true&lang=js"
export * from "./Tabs.vue?vue&type=script&setup=true&lang=js"

import "./Tabs.vue?vue&type=style&index=0&id=6d998d5f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d998d5f"]])

export default __exports__